import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import useUserStore from '../store/userStore';

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
  background: 'rgba(0,0,0,0.7)',
  fontFamily: "'Poppins', sans-serif",
  cursor: 'pointer'
};

const modalStyle = {
  background: '#fff',
  padding: '40px',
  borderRadius: '20px',
  width: '420px',
  maxWidth: '90%',
  boxShadow: '0 8px 25px rgba(0,0,0,0.2)',
  fontFamily: "'Poppins', sans-serif",
  textAlign: 'center',
  cursor: 'auto'
};

const titleStyle = {
  marginTop: 0,
  marginBottom: '24px',
  fontWeight: 'bold',
  fontSize: '24px',
  color: '#333',
};

const checkboxWrapperStyle = (shake) => ({
  display: 'inline-flex',
  alignItems: 'center',
  marginTop: '16px',
  userSelect: 'none',
  fontSize: '16px',
  color: '#333',
  position: 'relative',
  animation: shake ? 'shake 0.4s' : 'none'
});

const linkStyle = {
  color: '#000',
  textDecoration: 'underline',
  marginLeft: '4px'
};

const actionsStyle = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '32px',
  alignItems: 'center'
};

const acceptButtonStyle = {
  border: 'none',
  borderRadius: '8px',
  padding: '10px 20px',
  fontSize: '14px',
  cursor: 'pointer',
  transition: 'background 0.3s ease',
  fontFamily: "'Poppins', sans-serif",
  background: '#000',
  color: '#fff',
  marginRight: '20px'
};

const textButtonStyle = {
  fontSize: '14px',
  color: '#333',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  textDecoration: 'underline',
  fontFamily: "'Poppins', sans-serif",
};

const keyframes = `
@keyframes shake {
  0% { transform: translateX(0); }
  20% { transform: translateX(-5px); }
  40% { transform: translateX(5px); }
  60% { transform: translateX(-5px); }
  80% { transform: translateX(5px); }
  100% { transform: translateX(0); }
}
`;

const TermsPopup = () => {
  const [checked, setChecked] = useState(false);
  const [shake, setShake] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  const isLoggedIn = useUserStore((state) => state.isLoggedIn);
  const accessToken = useUserStore((state) => state.accessToken);
  const acceptTerms = useUserStore((state) => state.acceptTerms);
  const showTermsPopup = useUserStore((state) => state.showTermsPopup);
  const closeTermsPopup = useUserStore((state) => state.closeTermsPopup);
  const termsAccepted = useUserStore((state) => state.termsAccepted);

  // Only run this after the component has mounted
  useEffect(() => {
    // Check if we should show the popup
    const isTermsPage = typeof window !== 'undefined' && window.location.pathname === '/terms';
    const shouldShowPopup = !isTermsPage && !termsAccepted && showTermsPopup;
    
    setShouldRender(shouldShowPopup);
  }, [termsAccepted, showTermsPopup]);

  const handleAccept = async (e) => {
    e.stopPropagation();
    if (!checked) {
      setShake(true);
      setTimeout(() => setShake(false), 500);
      return;
    }

    try {
      if (isLoggedIn) {
        await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/terms/accept`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
          }
        });
      }

      acceptTerms();
      closeTermsPopup();
    } catch (error) {
      console.error('Error accepting terms:', error);
    }
  };

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  const handleClose = (e) => {
    e.stopPropagation();
    closeTermsPopup();
  };

  // Don't render anything during SSR or if conditions not met
  if (!shouldRender) {
    return null;
  }

  return (
    <>
      <style>{keyframes}</style>
      <div style={overlayStyle} onClick={handleClose}>
        <div style={modalStyle} onClick={handleModalClick}>
          <h2 style={titleStyle}>Before You Download</h2>
          <label style={checkboxWrapperStyle(shake)}>
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
              style={{ marginRight: '8px', transform: 'scale(1.2)', accentColor: '#000' }}
            />
            <span>
              I accept{' '}
              <Link href="/terms" target="_blank" rel="noopener noreferrer" style={linkStyle}>
                Terms & Conditions
              </Link>{' '}
              and{' '}
              <Link href="/privacy" target="_blank" rel="noopener noreferrer" style={linkStyle}>
                Privacy Policy
              </Link>
            </span>
          </label>
          <div style={actionsStyle}>
            <button style={acceptButtonStyle} onClick={handleAccept}>Accept</button>
            <button style={textButtonStyle} onClick={handleClose}>Cancel</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsPopup;